<template>
  <v-flex class="d-flex align-center justify-center" style="height: calc(100vh - 110px)">
    <div class="text-center d-flex flex-column align-center">
      <img alt="logo" :src="require('@/assets/img/logo.png')" width="200" class="mb-8" />
      <v-progress-linear :value="progress" color="primary" height="25" class="white" rounded>
        <template v-slot:default>
          <strong class="white--text">
            {{ Math.min(totalCompletedHours, 10) }} / 10 Lessons
          </strong>
        </template>
      </v-progress-linear>

      <v-card class="primary-gradient mt-5" width="90%">
        <v-card-text class="white--text text-center">
          Once you have completed required 10 hours driving lesson, you can
          request a certificate from {{ this.schoolName }}
        </v-card-text>
      </v-card>

      <v-checkbox dark v-model="isCompleted" label="I have completed required courses" class="font-weight-bold"
        :disabled="progress !== 100 || certificateRequested" />

      <v-btn x-large rounded class="font-weight-bold" :disabled="!isCompleted" v-if="!hasCertificate" :loading="loading"
        @click="certificateRequest">
        {{ this.buttonText }}
      </v-btn>
      <v-dialog v-model="dialog" scrollable max-width="300px" v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn x-large rounded class="font-weight-bold" v-bind="attrs" v-on="on">
            View certification
          </v-btn>
        </template>
        <v-card>
          <iframe style="width: 100%; height: 80vh" :src="this.certificateLink" />
          <v-card-actions>
            <v-btn block color="primary" :href="this.certificateLink" target="_blank">Download</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer />
      <v-alert type="warning" v-if="!hasSchoolPackage" class="mb-0 mt-5 text-left">Currently, you don't have a package
        from
        any school. Please buy a
        package.</v-alert>
      <v-alert type="warning" v-if="!statusPending" class="mb-0 mt-5 text-left">
        Certificate request is pending
      </v-alert>
    </div>
  </v-flex>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Parse from 'parse'

export default {
  data () {
    return {
      loading: false,
      totalCompletedHours: 0,
      hasSchoolPackage: true,
      isCompleted: false,
      hasCertificate: false,
      dialog: false,
      schoolName: null,
      schoolEmail: null,
      schoolId: null,
      buttonText: 'Request certification',
      statusPending: true,
      certificateRequested: false,
      certificateLink: ''
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'schoolPackageJoinedId',
      'completedHours',
      'requestCertificate',
      'certificate'
    ]),
    progress () {
      return (this.totalCompletedHours * 100) / 10
    }
  },
  methods: {
    ...mapActions([
      'toggleDialog',
      'getSchoolPackageJoinedById',
      'getCompletedHours',
      'addRequestCertificate',
      'getCertificate'
    ]),
    async certificateRequest () {
      if (this.schoolId) {
        this.loading = true
        await this.addRequestCertificate({
          userId: this.user.id,
          schoolId: this.schoolId,
          schoolEmail: this.schoolEmail,
          studentName: this.user.get('firstName') + ' ' + this.user.get('lastName')
        })
        if (this.requestCertificate) {
          this.certificateRequested = true
          this.buttonText = 'Certificate requested'
          this.statusPending = false
        }
        this.loading = false
      } else {
        this.toggleDialog({
          status: true,
          title: 'Error',
          message: 'Something went wrong, please try again.'
        })
      }
    }
  },
  async created () {
    this.isLoading = true
    /** Get the school package information this student joined */
    await this.getSchoolPackageJoinedById({
      studentId: this.user.id
    })
    if (this.schoolPackageJoinedId) {
      this.schoolId = this.schoolPackageJoinedId.get('schoolId').id
      this.schoolName = this.schoolPackageJoinedId.get('schoolId').get('name')
      this.schoolEmail = this.schoolPackageJoinedId.get('schoolId').get('associatedId').get('username')
      /** Show the total completed hours from this school by this student */
      const Appointments = Parse.Object.extend('Appointments')
      const query = new Parse.Query(Appointments)
      const User = Parse.Object.extend('_User')
      const userPointer = new User()
      userPointer.id = this.user.id
      query.equalTo('studentId', userPointer)

      const SchoolPackages = Parse.Object.extend('SchoolPackages')
      const schoolPackagePointer = new SchoolPackages()
      schoolPackagePointer.id = this.schoolPackageJoinedId.get('schoolPackageId').id
      // query.equalTo('schoolPackageId', schoolPackagePointer)

      query.equalTo('status', 'Finished')
      query.limit(1000)

      try {
        const results = await query.find()
        let totalHours = 0
        results.forEach(app => {
          const hours = parseFloat(app.get('hoursLesson')) || 'hourslesson' || 0
          totalHours += hours
        })
        this.totalCompletedHours = totalHours
        this.isCompleted = this.totalCompletedHours >= 10
        console.log('Total completed hours === ', totalHours)
      } catch (error) {
        console.error('Error fetching completed hours:', error)
        this.totalCompletedHours = 0
      }
      this.isLoading = false

      /** See if certificate request was sent */
      await this.getCertificate({
        userId: this.user.id,
        schoolId: this.schoolId
      })
      if (this.certificate) {
        this.certificateRequested = true
        if (!this.certificate.get('status')) {
          this.buttonText = 'Certificate requested'
          this.statusPending = false
        } else {
          this.hasCertificate = true
          this.certificateLink = this.certificate.get('certificateFile')._url
        }
      }
    } else {
      this.hasSchoolPackage = false
    }
  }
}
</script>
